import { render, staticRenderFns } from "./ContentPanel.vue?vue&type=template&id=5a8047a9&scoped=true&"
import script from "./ContentPanel.vue?vue&type=script&lang=js&"
export * from "./ContentPanel.vue?vue&type=script&lang=js&"
import style0 from "./ContentPanel.vue?vue&type=style&index=0&id=5a8047a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8047a9",
  null
  
)

export default component.exports